import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Forbidden from '@/views/Forbidden.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/:number?/:token?',
        name: 'Home',
        component: Home
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        component: Forbidden
    }

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router